


import React from "react"
import './PaperFoldBox.scss'
var classNames = require('classnames');

export const PaperFoldBox = ({className = '', ...props}) => {
    return (<div className={classNames('paper', { 'transparent': props.transparent }, className)}>
             <div className="paper-content">
                 {props.children}
             </div>
             {props.buttons}
         </div>)
    
}